import {
    /** FETCH GETDISTRICT  */
    FETCH_GETDISTRICT_FULFILLED,
    FETCH_GETDISTRICT_REJECTED,
    FETCH_GETDISTRICT_PENDING,
    RESET_GETDISTRICT,
  } from "../../actions/payment/getDistrict";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETDISTRICT_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_GETDISTRICT_FULFILLED:
        return {
          ...state,
          getDistrict: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_GETDISTRICT_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_GETDISTRICT:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  